import { render, staticRenderFns } from "./PPanelSimpleInputNumber.vue?vue&type=template&id=025bb53f"
import script from "./PPanelSimpleInputNumber.vue?vue&type=script&lang=js"
export * from "./PPanelSimpleInputNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports